import "./details.scss";
import React from "react";
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';

import { Swiper, SwiperSlide} from 'swiper/react';
import projects from '../../services/mockdata.js';

import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";

function DetailsPage() {
  const params = useParams();
  const project = projects[Number(params.id)];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className='details'>
        <div className="container">
          <div className="details__inner">

            <div className="details-info">
              <h1 className="info-title">
                {/* Photo-Artist portfolio website */}
                {project.title}
              </h1>
              <p className="info-subtitle">
                Website was created for photographer to demonstrate
                his work, projects
                {project.description}
              </p>
              <div className="slider">
                <Swiper
                  className="project-slider"
                  modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                  slidesPerView={3}
                  loop={true}
                  spaceBetween={25}
                  autoplay
                >
                  {project.images.map(img => (
                    <SwiperSlide className="details-image" key={img.id}>
                      <img src={"/assets/" + img.src} alt={project.title} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>

              <div className="project-details">
                <h2 className="info-stack">
                  Stack
                </h2>
                <p>
                  {/* Angular, RxJS, TypeScript */}
                  {project.stack}
                </p>
              </div>
              <div className="project-details">
                <h2 className="info-stack">
                  Tools
                </h2>
                <p>
                  {/* Git, Google Firebase, Figma */}
                  {project.tools}
                </p>
              </div>
              <div className="project-date">
                {/* 2021 */}
                {project.date}
              </div>
            </div>
          </div>
        </div >
      </div >
    </motion.div>
  )
}

export default DetailsPage